import Attachment from 'models/attachment';
import createModel, { prop } from 'models/lib/create_model';

const TaskEmail = createModel({
  modelName: 'TaskEmail',

  properties: {
    id: String,
    direction: String, // INBOUND (from the third party) or OUTBOUND (from an agent)
    from: String,
    fromName: String, // display name of the sender, when the email carried one
    agentId: String, // the sending agent, for OUTBOUND emails
    // The thread endpoint returns recipients as normalized address strings, unlike the {email, name}
    // objects it accepts on send.
    to: [String],
    cc: [String],
    bcc: [String],
    attachments: prop([Attachment]).default([]),
    subject: String,
    bodyHtml: String,
    bodyPlain: String, // set when the email has no HTML body (plain-text-only mail)
    timestamp: String,
  },

  isInbound() {
    return this.direction === 'INBOUND';
  },

  isOutbound() {
    return this.direction === 'OUTBOUND';
  },

  // Inline images are rendered by the body's cid: references, not as attachment cards.
  regularAttachments() {
    return this.attachments.filter(attachment => !attachment.isInline);
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },

    fromThreadItem(item) {
      return this.fromJs({
        id: item.id,
        direction: item.direction,
        agentId: item.agentId,
        timestamp: item.timestamp,
        ...item.email,
      });
    },
  },
});

export default TaskEmail;
